import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "@/components/digindia/ThemeProvider";
import Navigation from "@/components/digindia/Navigation";
import Hero from "@/components/digindia/Hero";
import Services from "@/components/digindia/Services";
import BeforeAfter from "@/components/digindia/BeforeAfter";
import ChatbotPreview from "@/components/digindia/ChatbotPreview";
import EnquiryForm from "@/components/digindia/EnquiryForm";
import CTASection from "@/components/digindia/CTASection";
import Footer from "@/components/digindia/Footer";
import FloatingChat from "@/components/digindia/FloatingChat";
import ScrollProgress from "@/components/digindia/ScrollProgress";
import CustomCursor from "@/components/digindia/CustomCursor";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Contact from "@/pages/Contact";

const Landing = () => {
  const { theme } = useTheme();
  const scrollToEnquiry = () => {
    const el = document.getElementById("enquiry");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="min-h-screen bg-background text-foreground antialiased" data-testid="landing-root">
      <ScrollProgress />
      <Navigation />
      <main>
        <Hero onCTA={scrollToEnquiry} />
        <Services />
        <BeforeAfter />
        <ChatbotPreview />
        <EnquiryForm />
        <CTASection onCTA={scrollToEnquiry} />
      </main>
      <Footer />
      <FloatingChat />
      <Toaster
        theme={theme}
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          classNames: {
            toast: "rounded-xl border border-border",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <CustomCursor />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
